<template>
  <advanced-table
    :headers="headers"
    :filters="filters"
    :sortBy="['date']"
    :sortDesc="[true]"
    :resource="resource"
    :optionLists="optionLists"
  />
</template>

<script>
import AdvancedTable from "@/components/AdvancedTable.vue";

export default {
  data() {
    return {
      clickedImei: null,
      headers: [
        {
          text: "תאריך שילוח",
          value: "date",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? this.heDate(data[key]) : "לא ידוע";
          },
          linkTo: (item) => {
            return `/deliveries/${item._id}`;
          }
        },
        {
          text: "חנות ביניים",
          value: "tempStore",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            let store = this.$store.state.entities.stores[
              data[key]
            ];
            if (store) {
              return store.title;
            }
            return "לא ידוע";
          }
        },
        {
          text: "האם הגיע",
          value: "isDeliveredToFinalStore",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? 'כן' : 'לא';
          }
        },
        {
          text: "תאריך יצירה",
          value: "created",
          align: "start",
          visible: false,
          displayFunc: (data, key) => {
            return data[key] ? this.heDate(data[key]) : "לא ידוע";
          }
        }
      ],
      filters: [
        {
          type: "DATE",
          label: "נוצר אחרי",
          model: "createdAfter",
          active: false
        },
        {
          type: "DATE",
          label: "נוצר לפני",
          model: "createdBefore",
          active: false
        }
      ]
    };
  },
  computed: {
    resource() {
      return this.$store.state.resources["delivery"];
    },
    optionLists() {
      return {};
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  },
  methods: {
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    },
    heDate(d) {
      let date = new Date(d);
      let options = { weekday: "long", month: "long", day: "numeric" };
      return new Intl.DateTimeFormat("he-IL", options).format(date);
    }
  },

  watch: {},

  components: {
    AdvancedTable
  }
};
</script>